var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubTrafficBackend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400,140 C256.7,140 140,256.7 140,400 C140,514.8 215.2,612.1 319.4,645.3 C334.4,648.1 339.9,638.8 339.9,630.7 C339.9,623.4 339.6,602.1 339.6,580.8 C270,595.8 250.7,543.6 250.7,543.6 C235.7,513.6 213.7,504.3 213.7,504.3 C183.7,485.7 215.7,486.4 215.7,486.4 C248.7,488.5 266.4,517.1 266.4,517.1 C295.7,563.6 343.6,545 340.7,536.9 C343.5,517.1 353.5,503.5 364.2,495.7 C308.5,487.8 250,463.6 250,365 C250,335.7 263.5,311.4 287,292.8 C283.5,285.7 271.4,257.1 289.9,215.7 C289.9,215.7 317.1,205.7 339.9,239.2 C360,231.4 381.4,227.8 402.8,227.8 C424.2,227.8 445.6,231.4 465.7,239.2 C488.5,205.7 515.7,215.7 515.7,215.7 C534.2,257.1 522.1,285.7 518.5,292.8 C542.1,311.4 555.6,335.7 555.6,365 C555.6,463.6 497.1,487.1 441.4,494.9 C455,505.0 467.1,524.3 467.1,554.9 C467.1,598.5 466.4,620.6 466.4,630.7 C466.4,638.8 471.9,648.1 486.9,645.3 C591.1,612.1 666.3,514.8 666.3,400 C666.3,256.7 549.6,140 400,140",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 320)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 40,
    rx: 80,
    ry: 25,
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,40 L20,90",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,40 L180,90",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 90,
    rx: 80,
    ry: 25,
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,90 L20,140",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,90 L180,140",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 140,
    rx: 80,
    ry: 25,
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,140 L20,190",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,140 L180,190",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 190,
    rx: 80,
    ry: 25,
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 80,
    height: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 80,
    width: 80,
    height: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 110,
    width: 80,
    height: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 130,
    width: 80,
    height: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 160,
    width: 80,
    height: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 180,
    width: 80,
    height: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 50,
    r: 6,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 50,
    r: 6,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 6,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 50,
    r: 6,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 50,
    r: 6,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,50 L40,140",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeDasharray: "5,5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,50 L70,190",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeDasharray: "5,5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,50 L100,190",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,50 L130,140",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeDasharray: "5,5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,50 L160,190",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeDasharray: "5,5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubTrafficBackend);
export default __webpack_public_path__ + "static/media/github-traffic-backend.1d3574067be101b07cea29aac1ab2e2e.svg";
export { ForwardRef as ReactComponent };